import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { PickupCreated, PickupRelations } from './pickup.models';
import { PickupService } from './pickup.service';
import { PickupDialogComponent } from './pickup-dialog.component';

@Component({
  selector: 'app-work-order-pickups',
  standalone: true,
  imports: [CommonModule, MatDialogModule, RouterModule],
  templateUrl: './work-order-pickups.component.html'
})
export class WorkOrderPickupsComponent implements OnChanges, OnDestroy {
  @Input() ladingUuid: string | null = null;
  relations: PickupRelations | null = null;
  created: PickupCreated | null = null;
  loading = false;
  printing = false;
  error = '';
  private subscription?: Subscription;
  private documentRequest?: Subscription;

  constructor(private readonly api: PickupService, private readonly dialog: MatDialog) {}

  ngOnChanges(): void {
    this.created = null;
    this.relations = null;
    this.load();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.documentRequest?.unsubscribe();
  }

  load(): void {
    this.subscription?.unsubscribe();
    this.error = '';
    if (!this.ladingUuid) return;
    this.loading = true;
    this.subscription = this.api.relations(this.ladingUuid).subscribe({
      next: result => { this.relations = result; this.loading = false; },
      error: error => { this.error = error?.error?.message || 'Pickup links could not be loaded.'; this.loading = false; }
    });
  }

  create(): void {
    const uuid = this.ladingUuid;
    if (!uuid) return;
    this.dialog.open(PickupDialogComponent, {
      data: { ladingUuid: uuid }, width: '960px', maxWidth: '96vw', maxHeight: '90vh',
      autoFocus: false, ariaLabelledBy: 'pickup-dialog-title'
    }).afterClosed().subscribe((created?: PickupCreated) => {
      if (created && uuid === this.ladingUuid) { this.created = created; this.load(); }
    });
  }

  print(): void {
    if (!this.ladingUuid || this.printing) return;
    this.printing = true;
    this.error = '';
    const filename = `pickup-${this.relations?.lading.alternate_reference || this.ladingUuid}.pdf`;
    this.documentRequest = this.api.document(this.ladingUuid).subscribe({
      next: blob => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
        this.printing = false;
      },
      error: () => { this.error = 'The pickup document could not be loaded. Please retry.'; this.printing = false; }
    });
  }
}
